/* eslint-disable max-len */

import React, { DetailedHTMLProps, HTMLAttributes } from 'react'

interface Props extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  svgStyles?: string
}

const TickSvg = (props: Props): JSX.Element => {
  const { svgStyles, ...rest } = props

  const img = `
  <svg  class="${props.svgStyles ?? ''}" xmlns="http://www.w3.org/2000/svg" width="7" height="4" viewBox="0 0 7 4">
    <path id="Path_337" data-name="Path 337" d="M12,13,9.5,11h5Z" transform="translate(-8.5 -10)" fill="none" stroke="#464f56" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
  </svg>

  `
  return <div {...rest} dangerouslySetInnerHTML={{ __html: img }} />
}

export default TickSvg
